// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const Feed = require('client-v2/common/containers/feed/component-dumb')
const { createFeedSmartComponent } = require('client-v2/common/containers/feed/component-smart')
// Sibling imports
const feedActions = require('./actions')
const feedSelectors = require('./selectors')

const commonFeedSmartComponent = createFeedSmartComponent(feedActions, feedSelectors)
const { mapStateToProps, mapDispatchToProps } = commonFeedSmartComponent

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withImmutableToJS(
    Feed
  )
)
